import { FC, useState } from 'react';
import { Button, Dimmer, Form, Loader, Modal } from 'semantic-ui-react';
import * as uiActions from '../../actions/uiActions';
import { useDispatch } from 'react-redux';
import ServerConfigurationApi, {
    LookUpType,
} from '../../api/serverConfigurationApi';
import Text from '../common/fields/Text';
import TextArea from '../common/fields/TextArea';
import toastr from 'toastr';

interface SaveLookUpTypeModalProps {
    item: LookUpType;
    onSuccess: () => void;
}

const SaveLookUpTypeModal: FC<SaveLookUpTypeModalProps> = ({
    item,
    onSuccess,
}) => {
    const [isSaving, setIsSaving] = useState(false);
    const [formData, setFormData] = useState<LookUpType>({
        id: item?.id || null,
        lookUpTypeCode: item?.lookUpTypeCode || '',
        lookUpTypeLabel: item?.lookUpTypeLabel || '',
        lookUpTypeDescription: item?.lookUpTypeDescription || '',
    });
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(uiActions.closeModal());
    };

    const handleSaveEntity = async () => {
        try {
            setIsSaving(true);
            await ServerConfigurationApi.updateLookUpType(
                item ? { ...formData, id: item.id } : formData,
            );
            toastr.success('Look up type saved');
            onSuccess();
            handleClose();
            setIsSaving(false);
        } catch (error) {
            toastr.error(error);
            setIsSaving(false);
        }
    };

    const handleInputChanged = (event, { name, value, checked }) => {
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <Modal
            open={true}
            onClose={handleClose}
            size="small"
            closeOnDimmerClick={false}
        >
            <Dimmer active={isSaving} inverted>
                <Loader disabled={!isSaving} />
            </Dimmer>
            <Modal.Header>
                {item
                    ? `Update ${item.lookUpTypeLabel}`
                    : 'Create new look up type'}
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field
                        control={Text}
                        label="Code"
                        value={formData.lookUpTypeCode}
                        onChange={handleInputChanged}
                        name="lookUpTypeCode"
                    ></Form.Field>
                    <Form.Field
                        control={Text}
                        label="Label"
                        value={formData.lookUpTypeLabel}
                        onChange={handleInputChanged}
                        name="lookUpTypeLabel"
                    ></Form.Field>
                    <Form.Field
                        control={TextArea}
                        label="Description"
                        value={formData.lookUpTypeDescription}
                        onChange={handleInputChanged}
                        name="lookUpTypeDescription"
                    ></Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button positive onClick={handleSaveEntity}>
                    {item ? 'Update' : 'Save'}
                </Button>
                <Button secondary onClick={handleClose}>
                    Cancel
                </Button>
            </Modal.Actions>
        </Modal>
    );
};

export default SaveLookUpTypeModal;
